/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Avatar, Badge, Button, Drawer, Menu, Popover, message } from "antd";

import {
  PoweroffOutlined,
  MoonOutlined,
  SunOutlined,
  MenuOutlined,
  ApiOutlined,
} from "@ant-design/icons";
import { useAuth } from "../../../hooks";
// import MarkunreadOutlinedIcon from "@mui/icons-material/MarkunreadOutlined";
import NotificationAddOutlinedIcon from "@mui/icons-material/NotificationAddOutlined";
import "./MenuTop.css";
import Logo from "../../../assets/logo.png";
import LogoDark from "../../../assets/logo-dark.png";
import NoAvatar from "../../../assets/no-avatar.png";
import { DISPLAYNAME, EMAIL, USER } from "../../../config/constants";
import { BACKEND_URL } from "../../../config/config";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../../context";
import { useTheme } from "../../../context/ThemeContext";
import UserProfileModal from "../../UserProfileModal/UserProfileModal";
import { AdminMenu } from "../AdminMenu";
import { useMenuItems } from "../AdminMenu/useMenuItems";

export function MenuTop() {
  const { logout } = useAuth();
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const currentUser = JSON.parse(localStorage.getItem(USER));
  const navigate = useNavigate();
  const { notification } = useNotification();
  const { themeMode, toggleTheme } = useTheme();
  const headerLogo = themeMode === "dark" ? LogoDark : Logo;

  // NEW: open/close profile modal
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const mobileMenu = useMenuItems();

  const handleMobileNavClick = (e) => {
    setIsNavOpen(false);
    mobileMenu.onClick(e);
  };

  const logoutUser = async () => {
    const result = await logout();
    window.location.href = "/";
  };

  useEffect(() => {
    if (notification) setReload((r) => !r);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification]);

  const avatar = null;
  const email = localStorage.getItem(EMAIL);
  const fullName = localStorage.getItem(DISPLAYNAME);

  const [count, setCount] = useState(0);

  const navigateToNotifications = () => navigate("/notifications");

  const getNotifications = async () => {
    setIsLoading(true);
    const url = `${BACKEND_URL}/customerNotifications?id=${currentUser._id}&show=NOREADED`;
    const notificationsPayload = await axios
      .get(url)
      .catch((err) => console.log(err));
    setIsLoading(false);
    if (notificationsPayload?.data) {
      setCount(notificationsPayload.data.notifications.length);
    }
  };

  useEffect(() => {
    getNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const text = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span>Pothole Repair</span>
    </div>
  );

  const openEditProfile = () => setIsProfileOpen(true);
  const closeEditProfile = () => setIsProfileOpen(false);
  const goToImportData = () => navigate("/import-data");

  const handleProfileUpdated = (updatedUser) => {
    try {
      // Actualizamos localStorage en línea con tu app:
      localStorage.setItem(USER, JSON.stringify(updatedUser));
      if (updatedUser?.firstName || updatedUser?.lastName) {
        const display = `${updatedUser?.firstName || ""} ${
          updatedUser?.lastName || ""
        }`.trim();
        localStorage.setItem(DISPLAYNAME, display);
      }
      if (updatedUser?.email?.main) {
        localStorage.setItem(EMAIL, updatedUser.email.main);
      }
      message.success("Profile updated");
      setReload((r) => !r); // refrescar contadores/estado si hace falta
    } catch (_) {
      // noop
    }
  };

  const content = (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ marginRight: "15px" }}>
          <Avatar
            size={58}
            style={{ border: "3px solid var(--brand-primary, #2563eb)" }}
            src={
              avatar !== null &&
              avatar !== undefined &&
              avatar !== "null" &&
              avatar !== "undefined"
                ? avatar
                : NoAvatar
            }
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <span style={{ fontSize: "20px", fontWeight: "bold" }}>
            {fullName}
          </span>
          <span style={{ fontSize: "15px" }}>{email || ""}</span>
          <div
            role="button"
            tabIndex={0}
            onClick={goToImportData}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              paddingTop: 8,
              fontSize: 12,
              color: "var(--text-secondary, #888)",
              cursor: "pointer",
            }}
          >
            <ApiOutlined /> Import Data / API Access
          </div>
          <div style={{ display: "flex", gap: 8, paddingTop: 10 }}>
            <Button onClick={openEditProfile}>Edit Profile</Button>
            <Button onClick={logoutUser} style={{ marginLeft: "5px" }}>
              <PoweroffOutlined style={{ paddingRight: "5px" }} />
              Logout
            </Button>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className="menu-top">
        <div className="menu-top__left">
          <Button
            type="text"
            className="menu-top__icon-button menu-top__hamburger"
            onClick={() => setIsNavOpen(true)}
            aria-label="Open navigation menu"
          >
            <MenuOutlined style={{ fontSize: 20 }} />
          </Button>
          <img
            className="menu-top__left-logo"
            src={headerLogo}
            alt="Pothole Repair"
            onClick={() => (window.location.href = `/`)}
          />
        </div>

        <AdminMenu className="menu-top__nav" />

        <div className="menu-top__right">
          <Button
            type="text"
            className="menu-top__icon-button theme-toggle-button"
            onClick={toggleTheme}
            aria-label={
              themeMode === "dark" ? "Switch to light theme" : "Switch to dark theme"
            }
            title={themeMode === "dark" ? "Light theme" : "Dark theme"}
          >
            {themeMode === "dark" ? <SunOutlined /> : <MoonOutlined />}
          </Button>

          <Button
            type="text"
            className="menu-top__icon-button"
            onClick={navigateToNotifications}
            aria-label="Notifications"
          >
            <Badge count={count}>
              <NotificationAddOutlinedIcon
                className="menu-top__notification-icon"
                onClick={navigateToNotifications}
              />
            </Badge>
          </Button>

          <Popover
            placement="bottomRight"
            title={text}
            content={content}
            trigger="click"
          >
            <Avatar
              size="default"
              style={{
                border: "3px solid var(--brand-primary, #2563eb)",
                cursor: "pointer",
              }}
              src={
                avatar !== null &&
                avatar !== undefined &&
                avatar !== "null" &&
                avatar !== "undefined"
                  ? avatar
                  : NoAvatar
              }
            />
          </Popover>
        </div>
      </div>

      {/* Modal de edición de perfil */}
      <UserProfileModal
        open={isProfileOpen}
        onClose={closeEditProfile}
        user={currentUser}
        onUpdated={handleProfileUpdated}
      />

      <Drawer
        className="admin-drawer"
        placement="left"
        width={280}
        open={isNavOpen}
        onClose={() => setIsNavOpen(false)}
        title={
          <img className="menu-top__left-logo" src={headerLogo} alt="Pothole Repair" />
        }
      >
        <Menu
          className="admin-drawer-menu"
          mode="inline"
          onClick={handleMobileNavClick}
          selectedKeys={[mobileMenu.current]}
          items={mobileMenu.items}
        />
      </Drawer>
    </>
  );
}
